export const analyticsTaskData = (task) => {
  if(task){
    return { taskType: task.taskType, category: task.category, authorType: task.author ? task.author.type : undefined }
  }
}